<template>
  <div class="d-flex text-center align-items-center" style="height:100%">
    <div class="flex-column flex-row-fluid">
    <v-img
      class="white--text align-end"
      contain
      height="250px"
      src="/media/svg/illustrations/TMG-ours-timide-entier-face.png"
    />
    <h1 class="font-weight-boldest mb-12" v-html="$i18n.t('freemium.quotaReached.title')" />
    <h3 v-html="$i18n.t('freemium.quotaReached.message',{videosAuthorized: this.getNbVideoAuthorizedPerPeriod, videosPeriod : this.getNbDaysPeriod})"/>
    <div class="my-2">
      <a
        @click="goToDashboard"
        class="btn btn-primary align-self-end mx-5"
        >{{ $t("common.homepage") }}
      </a>
      <a @click="goToPreviousPage" class="btn btn-primary align-self-end mx-5">
        {{$t("common.back")}}
      </a>
      
    </div>
  </div>
  </div>
</template>
<script>
import { getUserVideosPeriod, getUserVideosAuthorized } from '@/core/utils/user';
import { mapGetters } from "vuex";
export default {
  name: "freemiumQuotaReached",
  data: () => ({}),
  props: {},
  methods: {
    goToDashboard(){
      this.$router.push({ name: 'tableauDeBord' });
    },
    goToPreviousPage(){
      this.$router.go(-1);
    }
  },
  computed: {
    ...mapGetters([
      "currentUser"
    ]),

    /**
     * Récupération des vidéos restantes à voir
     */
    getNbVideoAuthorizedPerPeriod(){
      return String(getUserVideosAuthorized(this.currentUser));
    }, 
    getNbDaysPeriod(){
      return String(getUserVideosPeriod(this.currentUser));
    }, 
  },
};
</script>
